import React, { Component, useState } from 'react'
import { Route } from 'react-router-dom'
import List from './List'
import CategoryInfo from './CategoryInfo'
import './Category.css'

const Category = (props) => {
  return (
      <Route exact path={`${props.match.url}/:id`} render={props => <CategoryInfo catID={props.match.params.id} />} />
  )
}

export default Category
